<!--<app-counselling-individuals-report></app-counselling-individuals-report>-->
<!--<app-counselling-group-session></app-counselling-group-session>-->
<!--<app-counselling-assessment-report></app-counselling-assessment-report>-->
<mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">

  <mat-tab label="Individual Sessions">

    <app-counselling-individuals-report></app-counselling-individuals-report>
  </mat-tab>

  <mat-tab label="Group Sessions"><app-counselling-group-session></app-counselling-group-session>
  </mat-tab>
  <mat-tab label="Assessments">
    <app-counselling-assessment-report></app-counselling-assessment-report>
  </mat-tab>
</mat-tab-group>
